module.exports = "/_next/static/images/UnifyCustomerProfileMobile@2x-336a0d4c1e51833530eeabbc95720cf0.png";